import React from 'react';
import { Checkbox } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CheckboxList = ({ id, value, onChange, editable }) => {
  if (!value) return null;

  const cbList = value.map((option, i) => {
    return (
      <Checkbox
        id={id}
        inline
        checked={option.checked}
        disabled={option.disabled || !editable}
        onChange={onChange.bind(this, i)}
        key={i}
      >
        {option.label}
      </Checkbox>
    );
  });

  return <div>{cbList}</div>;
};

CheckboxList.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool
};

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/components/form/CheckboxList.js